// extracted by mini-css-extract-plugin
export default {"header":"HeaderPage_header__fIa6k","badge":"HeaderPage_badge__F84Mc"};